<form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
  <h2 class="mb-1">
    <strong>Login</strong>
  </h2>
  <div>
    <p>Welcome to the QTAC ATAR Portal</p>
  </div>
  <div class="mb-1 qtac-error-container" *ngIf="genericError !== undefined">
    {{genericError}}
  </div>
  <div class="mb-1 qtac-error-container" *ngIf="showUserUnconfirmed">
    <span>
        Sorry, your account has not been confirmed. Please
        <a
            data-test="complete-registration-link"
            class="text-link"
            (click)="confirmSetup()"
            >click here</a
        >
        to complete your registration.
    </span>
  </div>
  <div class="mb-1">
    <div>Email Address *</div>
    <input
      class="qtac-input"
      data-test="login-input-email"
      name="email"
      type="email"
      formControlName="email"
      value=""
    />
    <small
      *ngIf="
        signInForm.controls['email'].hasError('required') &&
        signInForm.controls['email'].touched
      "
      class="form-error-msg error-msg"
      data-test="error-login-email"
    >
      Please provide an email
    </small>
    <small
      *ngIf="
        signInForm.controls['email'].hasError('email') &&
        signInForm.controls['email'].touched
      "
      class="form-error-msg error-msg"
      data-test="error-login-email"
    >
      Please provide a valid email
    </small>
  </div>

    <div class="mb-1">
        <div>Password *</div>
        <input
            class="qtac-input"
            data-test="login-input-password"
            type="password"
            name="password"
            formControlName="password"
            value=""
        />
        <small
            *ngIf="
                signInForm.controls['password'].hasError('required') &&
                signInForm.controls['password'].touched
            "
            class="form-error-msg error-msg"
            data-test="error-login-password"
        >
            Please provide a password
        </small>
    </div>

    <div class="mb-1">
        <a
            routerLink="/sessions/forgot-password"
            class="signin-forgot-text text-center full-width"
            data-test="forgot-password-link"
            >Forgot password?</a
        >
    </div>

    <button
        mat-raised-button
        class="full-width mb-1"
        data-test="submit-button-login"
        [disabled]="signInForm.invalid"
    >
        LOG IN
    </button>
</form>
